import { mapGetters, mapMutations } from "vuex";

export const filterModelMixin = {
  computed: {
    sex: {
      get() {
        return this.getSex;
      },
      set(value) {
        this.setFilterFieldByKeyValue({
          key: "sex",
          value
        });
      }
    },
    sustainable: {
      get() {
        return this.getSustainable;
      },
      set(value) {
        this.setFilterFieldByKeyValue({
          key: "sustainable",
          value
        });
      }
    },
    onSale: {
      get() {
        return this.getOnSale;
      },
      set(value) {
        this.setFilterFieldByKeyValue({
          key: "onSale",
          value
        });
      }
    },
    searchString: {
      get() {
        return this.getSearchString;
      },
      set(value) {
        this.setFilterFieldByKeyValue({
          key: "searchString",
          value
        });
      }
    },
    ...mapGetters({
      getSex: "filters/getSex",
      getSustainable: "filters/getSustainable",
      getOnSale: "filters/onSale",
      getSearchString: "filters/getSearchString"
    })
  },
  methods: {
    ...mapMutations({
      setFilterFieldByKeyValue: "filters/setFieldByKeyValue"
    })
  }
};
